// Emergent Google Auth helper.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
import axios from "axios";
import { API, apiRaw } from "./api";

// Configure apiRaw to send cookies for auth calls
apiRaw.defaults.withCredentials = true;

const EMERGENT_AUTH = "https://auth.emergentagent.com/";

// Start Google login. `to` is the path we want to land on after auth (e.g. "/signup", "/owner", "/mrsouth/admin/dashboard").
export const startGoogleLogin = (to = "/owner") => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
    const redirectUrl = `${window.location.origin}/auth/return?to=${encodeURIComponent(to)}`;
    window.location.href = `${EMERGENT_AUTH}?redirect=${encodeURIComponent(redirectUrl)}`;
};

// Exchange the session_id (URL fragment after Emergent redirect) for a persistent session cookie.
export const exchangeSession = async (sessionId) => {
    const r = await apiRaw.post("/auth/session", { session_id: sessionId }, { withCredentials: true });
    return r.data;
};

// Fetch current user (uses httpOnly cookie).
export const fetchMe = async () => {
    try {
        const r = await apiRaw.get("/auth/me", { withCredentials: true });
        return r.data.user;
    } catch {
        return null;
    }
};

export const fetchMyTenants = async () => {
    const r = await apiRaw.get("/auth/my-tenants", { withCredentials: true });
    return r.data.tenants || [];
};

export const logout = async () => {
    try {
        await apiRaw.post("/auth/logout", {}, { withCredentials: true });
    } catch {}
};

// Create a tenant while already authenticated.
export const signupTenantAsUser = async (payload) => {
    const r = await apiRaw.post("/auth/signup-tenant", payload, { withCredentials: true });
    return r.data;
};
